// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"45f2f89a","355":"95698d52","455":"5b824079","977":"54dbffa7"}[chunkId] + ".chunk.js";
};